var _circle, _mask, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _path2, _rect7, _rect8, _path3, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankYouIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    fill: "#FF5F14"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 69,
    height: 91,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 69,
    height: 91,
    rx: 2,
    fill: "#FF5F14",
    stroke: "white",
    strokeWidth: 14,
    mask: "url(#path-2-inside-1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 41,
    width: 33,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 60,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 49,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 56.0488L57.186 60L63 51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 82,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 71,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 78.0488L57.186 82L63 73",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 104,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 93,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100.049L57.186 104L63 95",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 39,
    width: 23,
    height: 4,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouIcon);
export default __webpack_public_path__ + "static/media/thankYouIcon.fd316613a007c98a52e49903afd6ec52.svg";
export { ForwardRef as ReactComponent };